module.exports = __webpack_public_path__ + "img/autospin_btn.f281d79b.png";